import { rootDomain, isProduction } from '../services/env';

const protocol = isProduction ? 'https://' : 'http://';

export function getSellerSubdomain(seller) {
  return `${protocol}${seller.name}.${rootDomain}`;
}

export function getSellerCustomDomain(seller) {
  return `${protocol}${seller.customDomain}`;
}

export default function getSellerDomain(seller) {
  if (seller.customDomain && seller.customDomainVerified) {
    return getSellerCustomDomain(seller);
  }

  return getSellerSubdomain(seller);
}
